<!-- Rate Card -->
<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 20px;">
  <!-- Rate header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0; text-align: center;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo de cambio</span>
    <div style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 6px;">
      <img src="assets/icons/zelle.png" alt="Zelle" style="width: 24px; height: 24px; object-fit: contain;">
      <span style="font-size: 1.3rem; font-weight: 800; color: #1e5a3f;">{{ zelle_buy_rate | number:'1.0-2' }} CLP = 1 USD</span>
      <img src="assets/flags/chile.png" alt="CLP" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover;">
    </div>
  </div>

  <!-- Saldo Actual -->
  <div style="padding: 14px 24px; text-align: center;"
    [style.border-bottom]="(lineaCredito! > 0 && !lineaCreditoBloqueada) || lineaCreditoBloqueada ? '1px solid #e5e7eb' : 'none'">
    <div style="display: flex; align-items: center; justify-content: center; gap: 6px;">
      <img src="assets/flags/chile.png" alt="CLP" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Saldo Actual</span>
    </div>
    <p style="font-size: 1.1rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">${{ saldoActual | currency:'':'' }} CLP</p>
  </div>

  <!-- Contable + Sobregiro -->
  <div *ngIf="lineaCredito! > 0 && !lineaCreditoBloqueada" class="grid grid-cols-2"
    style="border-bottom: 1px solid #e5e7eb;">
    <div style="padding: 12px 24px; text-align: center; border-right: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600;">Saldo Contable</span>
      <p style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">${{ saldoContable | currency:'':'' }}</p>
    </div>
    <div style="padding: 12px 24px; text-align: center;">
      <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600;">Sobregiro</span>
      <p style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f; margin: 2px 0 0;">${{ sobregiroDisponible | currency:'':'' }}</p>
    </div>
  </div>

  <!-- Línea bloqueada -->
  <div *ngIf="lineaCreditoBloqueada"
    style="padding: 10px 24px; text-align: center; background: #fef2f2;">
    <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626; vertical-align: middle; margin-right: 4px;">warning</mat-icon>
      Su línea de crédito se encuentra bloqueada
    </span>
  </div>
</div>

<!-- Calculator Card -->
<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 20px;">
  <div style="padding: 24px;">

    <!-- CLP Input -->
    <div style="margin-bottom: 20px;">
      <label style="display: flex; align-items: center; gap: 6px; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
        <img src="assets/flags/chile.png" alt="CLP" style="width: 18px; height: 18px; border-radius: 50%; object-fit: cover;">
        Tu envías CLP
      </label>
      <div style="position: relative;">
        <span style="position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.85rem; pointer-events: none; z-index: 2; display: flex; align-items: center; gap: 4px;">
          <img src="assets/flags/chile.png" alt="CLP" style="width: 16px; height: 16px; border-radius: 50%; object-fit: cover;">
          CLP
        </span>
        <input type="text"
          [(ngModel)]="valorClp"
          (keyup)="transformCurrency('clp')"
          placeholder="$"
          pattern="[0-9]*"
          (keypress)="soloNumeros($event)"
          maxlength="8"
          class="calc-input"
          style="width: 100%; padding: 14px 110px 14px 75px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1e5a3f; background: white; text-align: right; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
          onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
        <div style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); display: flex; align-items: center; gap: 6px;">
          <button *ngIf="valorClp !== ''" type="button" (click)="clearValAvailableCLP()"
            style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; background: #f3f4f6; border: none; border-radius: 50%; color: #6b7280; cursor: pointer; font-size: 0.8rem; transition: all 0.2s;"
            onmouseover="this.style.background='#e5e7eb'; this.style.color='#374151'" onmouseout="this.style.background='#f3f4f6'; this.style.color='#6b7280'">&#x2715;</button>
          <button type="button" (click)="maxValAvailableCLP()"
            style="background: #1C593D; color: white; border: none; border-radius: 8px; padding: 4px 12px; font-size: 0.75rem; font-weight: 700; cursor: pointer; transition: background 0.2s;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">MÁX.</button>
        </div>
      </div>
    </div>

    <!-- Arrow separator -->
    <div style="display: flex; justify-content: center; margin-bottom: 16px;">
      <div style="width: 36px; height: 36px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">arrow_downward</mat-icon>
      </div>
    </div>

    <!-- USD Zelle Input -->
    <div style="margin-bottom: 8px;">
      <label style="display: flex; align-items: center; gap: 6px; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
        <img src="assets/icons/zelle.png" alt="Zelle" style="width: 18px; height: 18px; object-fit: contain;">
        Tu recibes USD Zelle
      </label>
      <div style="position: relative;">
        <span style="position: absolute; left: 16px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.85rem; pointer-events: none; z-index: 2; display: flex; align-items: center; gap: 4px;">
          <img src="assets/icons/zelle.png" alt="Zelle" style="width: 16px; height: 16px; object-fit: contain;">
          USD
        </span>
        <input type="text"
          [(ngModel)]="valorZelle"
          (keyup)="transformCurrency('zelle')"
          placeholder="$"
          pattern="[0-9]*"
          (keypress)="soloNumeros($event)"
          maxlength="8"
          class="calc-input"
          style="width: 100%; padding: 14px 16px 14px 75px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1e5a3f; background: white; text-align: right; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
          onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
      </div>
    </div>

  </div>
</div>

<!-- Error messages -->
<div *ngIf="lineaCredito === null && clpCurrency > saldoActual"
  style="margin-bottom: 12px; padding: 10px 16px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; display: flex; align-items: center; gap: 8px;">
  <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">error</mat-icon>
  <span style="font-size: 0.8rem; font-weight: 600; color: #991b1b;">El monto de envío excede el saldo actual</span>
</div>

<div *ngIf="lineaCredito! > 0 && clpCurrency > saldoContable!"
  style="margin-bottom: 12px; padding: 10px 16px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; display: flex; align-items: center; gap: 8px;">
  <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">error</mat-icon>
  <span style="font-size: 0.8rem; font-weight: 600; color: #991b1b;">El monto de envío excede el saldo disponible</span>
</div>

<div *ngIf="minError"
  style="margin-bottom: 12px; padding: 10px 16px; background: #fef3c7; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; display: flex; align-items: center; gap: 8px;">
  <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #f59e0b;">warning</mat-icon>
  <span style="font-size: 0.8rem; font-weight: 600; color: #92400e;">El monto mínimo para enviar es de {{ minValue }} USD</span>
</div>

<div *ngIf="maxError"
  style="margin-bottom: 12px; padding: 10px 16px; background: #fef3c7; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; display: flex; align-items: center; gap: 8px;">
  <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #f59e0b;">warning</mat-icon>
  <span style="font-size: 0.8rem; font-weight: 600; color: #92400e;">El monto máximo para enviar es de {{ _limitSell }} USD</span>
</div>

<!-- Buttons -->
<div style="display: flex; gap: 12px;">
  <button type="button" (click)="goToBack()"
    style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 14px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">arrow_back</mat-icon>
    Volver
  </button>
  <button type="button" (click)="emitChangeStep()"
    [disabled]="clpCurrency === 0 || zelleCurrency === 0 || (lineaCredito === null && clpCurrency > saldoActual) || (lineaCredito! > 0 && clpCurrency > saldoContable!) || lineaCreditoBloqueada || maxError || minError"
    [style.opacity]="(clpCurrency === 0 || zelleCurrency === 0 || (lineaCredito === null && clpCurrency > saldoActual) || (lineaCredito! > 0 && clpCurrency > saldoContable!) || lineaCreditoBloqueada || maxError || minError) ? '0.5' : '1'"
    [style.cursor]="(clpCurrency === 0 || zelleCurrency === 0 || (lineaCredito === null && clpCurrency > saldoActual) || (lineaCredito! > 0 && clpCurrency > saldoContable!) || lineaCreditoBloqueada || maxError || minError) ? 'not-allowed' : 'pointer'"
    style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
    onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    Comprar
  </button>
</div>
